module.exports = __webpack_public_path__ + "static/media/lien-numerique.e570b19d.jpg";